import React, { useState, useEffect, useContext } from "react";
import Sidebar from "../../components/Sidebar";
import Typography from "@material-ui/core/Typography";
import { AuthContext } from "../../context/AuthContext";
import bg from "../../assets/images/marketing.jpg";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Breadcrumbs from '@material-ui/core/Breadcrumbs';

import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import Button from "@material-ui/core/Button";
import Icon from '@material-ui/core/Icon';
import {CloudDownload,Search} from "@material-ui/icons";
import moment from "moment";

const useStyle = makeStyles({
    table: {
        minWidth: 500,
    },
});
const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    button: {
        margin: theme.spacing(1),
    },
}));


const MonthlyActiveUser = () => {
    const classes = useStyles();
    const { auth } = useContext(AuthContext);
    const [analytics, setAnalytics] = useState([]);

    const getAnalytics = async () => {
        try {
            let url = `/api/analytic/monthly-active-user`;
            let res = await axios({
                url: url,
                method: "get",
                headers: {
                    Authorization: `Bearer ${auth.token}`,
                },
            });
            //console.log(res)
            setAnalytics(res.data.data);
        } catch (error) {
            if (error.response.status == 401) {
                console.log(error)
            }
        }
    };

    useEffect(() => {
        getAnalytics();
    }, []);

    let date = new Date(), y = date.getFullYear(), m = date.getMonth();
    let firstDay = new Date(y, m, 1);

    const [selectedDate, setSelectedDate] = React.useState(new Date(firstDay));
    const [endDate, setEndDate] = React.useState(new Date());

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };
    const handleEndDateChange = (date) => {
        setEndDate(date);
    };
    const handleSubmit= async () => {
        try {
            let url = `/api/analytic/monthly-active-user?date_from=${moment(selectedDate).format("YYYY-MM-DD")}&date_to=${moment(endDate).format("YYYY-MM-DD")}`;
            let res = await axios({
                url: url,
                method: "get",
                headers: {
                    Authorization: `Bearer ${auth.token}`,
                },
            });
            //console.log(res)
            setAnalytics(res.data.data);
        } catch (error) {
            if (error) {
                console.log(error)
            }
        }
    }

    const handleDownload = async() => {
        try {
            let url = `/api/export/monthly-active-user?date_from=${moment(selectedDate).format("YYYY-MM-DD")}&date_to=${moment(endDate).format("YYYY-MM-DD")}`;
            let res = await axios({
                url: url,
                method: "get",
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${auth.token}`,
                },
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `monthly-active-user-${Date.now()}.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
            //setAnalytics(res.data.data);
        } catch (error) {
            if (error) {
                console.log(error)
            }
        }
    }

    return (
        <div className="wrapper">
            <Sidebar />
            <div className="wrapper-inner">

                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container justifyContent="center">

                        <KeyboardDatePicker
                            disableToolbar
                            variant="inline"
                            format="MM/dd/yyyy"
                            autoOk={true}
                            margin="normal"
                            id="date-picker-inline"
                            label="Start Date"
                            value={selectedDate}
                            onChange={handleDateChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                        <KeyboardDatePicker
                            disableToolbar
                            variant="inline"
                            format="MM/dd/yyyy"
                            autoOk={true}
                            margin="normal"
                            id="date-picker-inline"
                            label="End Date"
                            value={endDate}
                            onChange={handleEndDateChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                        <div className={classes.root} style={{ alignItems:'end', display:'flex', marginLeft:20, paddingBottom:8 }}>
                            <Button
                                size="small"
                                variant="outlined"
                                color="default"
                                onClick={handleSubmit}
                                startIcon={<Search />}
                            >
                                Search
                            </Button>
                        </div>
                    </Grid>
                </MuiPickersUtilsProvider>

                <div style={{ display:"flex", justifyContent:"space-between"}}>
                    <Breadcrumbs aria-label="breadcrumb" style={{ marginLeft:20}}>
                        <p>Analytic</p>
                        <Typography color="textPrimary">Monthly Active User</Typography>
                    </Breadcrumbs>
                    <div className={classes.root} style={{ alignItems:'end', display:'flex', marginLeft:20, paddingBottom:8 }}>
                        <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            endIcon={<CloudDownload />}
                            onClick={handleDownload}
                        >
                            Download File
                        </Button>
                    </div>
                </div>
                <div className="table" style={{ padding: 20 }}>
                    <TableContainer component={Paper} style={{ width:'98%'}}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Date</TableCell>
                                    <TableCell align="center">Active User</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {analytics.map((row) => (
                                    <TableRow key={row.date}>
                                        <TableCell component="th" scope="row" align="center">
                                            {row.date}
                                        </TableCell>
                                        <TableCell align="center">{row.count}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </div>
    );
};

export default MonthlyActiveUser;
